import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// window.screen.orientation.lock("portrait").catch(alert);   // webkit only
// todo add fullscreen button
// document.body.onclick = () => {
//     document.body.requestFullscreen({
//         navigationUI: 'hide'
//     })
//         .then(() => window.screen.orientation.lock("portrait"))
//         .catch(alert)
// }

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
